import { render, staticRenderFns } from "./Signature.vue?vue&type=template&id=389f31d1&scoped=true"
import script from "./Signature.vue?vue&type=script&lang=js"
export * from "./Signature.vue?vue&type=script&lang=js"
import style0 from "./Signature.vue?vue&type=style&index=0&id=389f31d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389f31d1",
  null
  
)

export default component.exports